import { Close as CloseIcon } from "@mui/icons-material";
import {
  Alert,
  Box,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import Button from "components/common/Button";
import React from "react";

const ReportPreviewDialog = ({
  open,
  onClose,
  title,
  data,
  loading,
  error,
}) => {
  const previewColumns = data?.[0]?.columns ?? [];
  const previewRows = data?.[0]?.tableContents ?? [];

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      fullWidth
      slotProps={{ paper: { sx: { maxWidth: "90vw", maxHeight: "80vh" } } }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          pr: 1,
        }}
      >
        <Typography variant={"h6"} component={"span"}>
          {"Preview"}
          {title ? ` — ${title}` : ""}
        </Typography>
        <IconButton onClick={onClose} size={"small"} aria-label={"close"}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers sx={{ p: 0 }}>
        {loading && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              py: 6,
            }}
          >
            <CircularProgress size={32} />
            <Typography
              variant={"body2"}
              color={"text.secondary"}
              sx={{ ml: 2 }}
            >
              {"Loading preview..."}
            </Typography>
          </Box>
        )}
        {error && (
          <Box sx={{ p: 3 }}>
            <Alert severity={"error"}>{"Failed to load preview."}</Alert>
          </Box>
        )}
        {!loading && !error && previewRows.length === 0 && data && (
          <Box sx={{ p: 3, textAlign: "center" }}>
            <Typography variant={"body2"} color={"text.secondary"}>
              {"No data available."}
            </Typography>
          </Box>
        )}
        {!loading && !error && previewRows.length > 0 && (
          <TableContainer sx={{ maxHeight: "60vh" }}>
            <Table stickyHeader size={"small"}>
              <TableHead>
                <TableRow>
                  {previewColumns.map((col) => (
                    <TableCell
                      key={col.internalName}
                      sx={{
                        fontWeight: 600,
                        whiteSpace: "nowrap",
                        backgroundColor: "grey.100",
                      }}
                    >
                      {col.displayName || col.internalName}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {previewRows.map((row, rowIdx) => (
                  <TableRow key={rowIdx} hover>
                    {previewColumns.map((col) => (
                      <TableCell
                        key={col.internalName}
                        sx={{ whiteSpace: "nowrap" }}
                      >
                        {row[col.internalName] != null
                          ? String(row[col.internalName]).slice(0, 40)
                          : ""}
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant={"outlined"}>
          {"Close"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ReportPreviewDialog;
